<template>
      <div class="bg-gray-200 min-h-screen relative">
        <div v-if="isLoggedIn!==null && isLoggedIn!==false"> 
          <!-- <Sidebar/> -->
            <div class="pb-16">
              <top-navigation/>
              <div>
                <main class="w-full mx-auto text-xs">
                  <router-view />
                </main>
              </div>
            </div>
            <footer-component class="absolute bottom-0 left-0 right-0 h-16"/>
        </div>

        <div v-else>
          <router-view />
        </div>
    </div> 
</template>

<script setup>
import { reactive, watch, computed  } from 'vue'
import Sidebar from './components/sidebar/Sidebar'
import TopNavigation from './components/sidebar/TopNavigation'
import FooterComponent from '@/components/Footer.vue'
import { useStore } from 'vuex'


const store = useStore()

let isLoggedIn = computed(() => {
  return store.getters['auth/isAuthenticated']
})
</script>
